<h2 mat-dialog-title style="font-size: 20pt; color: darkred;padding-bottom:10px;text-align:center;">WARNING</h2>
<mat-dialog-content>
    <div style="padding-bottom:10px;">The following students have been unselected from some classes, but not ALL
        classes:
    </div>
    <div style="padding-bottom:10px;">
        <div *ngFor="let student of deSelectedStudents">{{student}}</div>
    </div>
    <div style="padding-bottom:10px;">If your intent was to exclude these students from receiving this email,
        <span style="font-weight:bold;">Go Back</span> to the Student View tab and unselect the students. (That will
        unselect them from all classes.)
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-right'>
        <tyl-button style="float:left;" image="previous arrow.png" label="Go Back" (clickEvent)="backClick()"></tyl-button>
        <tyl-button style="float:right;" image="next arrow.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
    </div>
</mat-dialog-actions>